<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { StackLayout } from '@/components/Layouts'
import { TypographyWithPrefix } from '@/components/Typography'
import type { TicketModel } from '@/types/models/TicketModel'
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'

type Props = {
    data?: TicketModel
}
defineProps<Props>()
</script>

<template>
    <StackLayout :gap="8" isResponsive>
        <InformationBaseCard
            :label="$t('technician.ticket.detail.information')"
            :data="data"
            class="full-width">
            <StackLayout direction="column" isResponsive>
                <TypographyWithPrefix
                    :prefix="$t('technician.ticket.model.name')"
                    :label="data?.object"
                    boldLabel />
                <TypographyWithPrefix
                    :prefix="$t('technician.ticket.model.topic')"
                    :label="data?.topic_id"
                    boldLabel />
                <TypographyWithPrefix
                    :prefix="$t('technician.ticket.model.startDate')"
                    :label="moment(data?.start_date).format(DATETIME_FORMAT)"
                    boldLabel />
                <TypographyWithPrefix
                    :prefix="$t('technician.ticket.model.severity')"
                    :label="data?.severity_id"
                    boldLabel />
                <TypographyWithPrefix
                    :prefix="$t('technician.ticket.model.serialNumber')"
                    :label="data?.serial_number"
                    boldLabel></TypographyWithPrefix>
            </StackLayout>
        </InformationBaseCard>

        <InformationBaseCard :label="$t('technician.ticket.detail.description')" class="full-width">
            <TypographyWithPrefix :label="data?.description" />
        </InformationBaseCard>
    </StackLayout>
</template>
